import { FilterEraserIcon } from "./FilterEraserIcon";
import { FilterFunnelIcon } from "./FilterFunnelIcon";

const FUNNEL_SIZE = 16.5;
const ERASER_SIZE = FUNNEL_SIZE * 0.7;

export function FilterFunnelButton({
  open,
  active,
  count,
  onClick,
}: {
  open: boolean;
  active: boolean;
  count: number;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className={`map-control-btn workspace-filter-btn${active ? " on" : ""}`}
      aria-label="Filters"
      aria-expanded={open}
      title={count ? `Filters · ${count} on` : "Filters"}
      onClick={onClick}
    >
      <FilterFunnelIcon size={FUNNEL_SIZE} />
      {count > 0 ? <span className="map-filter-badge">{count}</span> : null}
    </button>
  );
}

export function FilterClearButton({
  active,
  onClick,
}: {
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className="workspace-filter-clear-btn"
      aria-label="Clear filters"
      title="Clear filters"
      disabled={!active}
      onClick={onClick}
    >
      <FilterEraserIcon size={ERASER_SIZE} />
    </button>
  );
}
